// Angular
import { Component, ViewEncapsulation, Input } from '@angular/core';

// Alfresco
import {
  ContentMetadataCardComponent,
  ContentService,
  NodeAspectService,
  VersionCompatibilityService,
} from '@alfresco/adf-content-services';

@Component({
  selector: 'wk-content-metadata-card',
  templateUrl: './wk-content-metadata-card.component.html',
  styleUrls: ['./wk-content-metadata-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: { class: 'adf-content-metadata-card' },
  standalone: false,
})
export class WkContentMetadataCardComponent extends ContentMetadataCardComponent {
  @Input()
  set isEditMode(isEditable: boolean) {
    if (!this.readOnly) {
      this.editable = isEditable;
    }
  }

  get isEditMode() {
    return this.editable;
  }

  constructor(
    contentService: ContentService,
    nodeAspectService: NodeAspectService,
    versionCompatibilityService: VersionCompatibilityService
  ) {
    super(contentService, nodeAspectService, versionCompatibilityService);
  }

  onDisplayDefaultPropertiesChange(): void {
    this.expanded = this.displayDefaultProperties;
  }

  public toggleEdit(): boolean {
    // toggleEdit function was removed and replaced for the variable editable
    this.editable = !this.editable;
    return this.editable;
  }

  public toggleExpanded(): boolean {
    // toggleExpanded function was removed and replaced for the variable expanded
    this.expanded = !this.expanded;
    return this.expanded;
  }
}
